import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'math', 'Math', [["path",{"d":"M19 5h-7l-4 14l-3 -6h-2"}],["path",{"d":"M14 13l6 6"}],["path",{"d":"M14 19l6 -6"}]]);